import { render, staticRenderFns } from "./dom-perignon.vue?vue&type=template&id=4d15fed3&scoped=true"
import script from "./dom-perignon.vue?vue&type=script&lang=js"
export * from "./dom-perignon.vue?vue&type=script&lang=js"
import style0 from "./dom-perignon.vue?vue&type=style&index=0&id=4d15fed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15fed3",
  null
  
)

export default component.exports